import React, { useState, useEffect} from 'react';
import { Input, Button} from 'antd';


import storage from "../../../../../utils/storage";
import "./index.scss";

const SearchInput = () => {
    const [searchValue, setSearchValue] = useState('');
    
    const onSearchValueChange = (e) => {
        setSearchValue(e.target.value)
    }

    
    const onSearch = () => {
        let searchValueTrim = searchValue.trim()
        storage.setItem('searchData', JSON.stringify({
            text:searchValueTrim,
            searchType: '1'
        }));
        window.open('/page/knowledgeSearchES');
        setSearchValue('');
    }

    return (
        <div className="searchInput">
            <div className="searchBar">
                <Input
                    value={searchValue}
                    placeholder="输入关键词进行搜索"
                    size={"large"}
                    bordered={false}
                    onChange={onSearchValueChange}
                    onPressEnter={onSearch}
                />
                <Button 
                onClick={onSearch} 
                type="primary" 
                size={"large"}>搜索一下</Button>
            </div>
        </div>
    );
}
export default SearchInput;
